module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/how-vux-loader-works-314.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/vux-loader/how-vux-loader-works.md
// module id = 779
// module chunks = 436